import { Location } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MunicionRecomendadaComponent } from 'src/app/newComponents/municion-recomendada/municion-recomendada.component';
import { RegisterService } from 'src/app/services/auth/register/register.service';
import { MyDataService } from 'src/app/services/data/data.service';
import { DiagnosisService } from 'src/app/services/diagnosis/diagnosis.service';
import { MailService } from 'src/app/services/mail/mail.service';
import { SnackBarService } from 'src/app/services/snackBar/snack-bar.service';
import { TicketsService } from 'src/app/services/tickets/tickets.service';
import { UbicacionesService } from 'src/app/services/ubicaciones/ubicaciones.service';
import { PhotoCaptureComponent } from '../nuevo-caso/photo-capture/photo-capture.component';

@Component({
  selector: 'app-acceso-sin-registro',
  templateUrl: './acceso-sin-registro.component.html',
  styleUrls: ['./acceso-sin-registro.component.scss'],
})
export class AccesoSinRegistroWebComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private destroyed$ = new Subject<void>();

  public formDatos: FormGroup;

  @ViewChild('numSerie2Input') numSerie2Input!: ElementRef;
  @ViewChild('numSerie3Input') numSerie3Input!: ElementRef;
  @ViewChild('numSerie4Input') numSerie4Input!: ElementRef;

  paises: any = [];

  symptonCodes: any = [];
  sectionCodes: any = [];
  pasosCategory: any = [];

  validEmail: any = undefined;

  step: 1 | 2 | 3 = 1;

  adjuntos: any = [];

  camposBlocked: string[] = [];

  activeLang: string = 'es';

  constructor(
    private _formBuilder: FormBuilder,
    private snackBarService: SnackBarService,
    private ubicacionesSvc: UbicacionesService,
    private diagnosisService: DiagnosisService,
    private registerSvc: RegisterService,
    private dataSvc: MyDataService,
    private ticketsSvc: TicketsService,
    private mailService: MailService,
    private router: Router,
    private location: Location,
    private dialog: MatDialog,
    private translocoService: TranslocoService
  ) {
    this.formDatos = this._formBuilder.group({
      nombre: ['', [Validators.required, Validators.maxLength(250)]],
      apellidos: ['', [Validators.required, Validators.maxLength(250)]],
      cp: ['', [Validators.required, Validators.maxLength(250)]],
      phone: ['', [Validators.required, Validators.maxLength(250)]],
      numserie1: ['', [Validators.required, Validators.maxLength(250)]],
      numserie2: ['', [Validators.required, Validators.maxLength(250)]],
      numserie3: ['', [Validators.required, Validators.maxLength(250)]],
      numserie4: ['', [Validators.required, Validators.maxLength(250)]],
      pais: ['', [Validators.required, Validators.maxLength(250)]],
      problema: ['', [Validators.required, Validators.maxLength(250)]],
      seccion: ['', [Validators.maxLength(250)]],
      politica: ['', [Validators.required, Validators.maxLength(250)]],
      email: ['', [Validators.required, Validators.maxLength(200)]],
      motivo: ['', [Validators.maxLength(250)]],
    });
  }

  ngOnInit(): void {
    const proyectoPlatform = this.dataSvc.getFkEntityPlatform();
    this.getPaises();
    if (proyectoPlatform) {
      this.getSymptonCodes(proyectoPlatform);
      this.getSectionCodes(proyectoPlatform);
    } else {
      this.dataSvc.getFkEntityPlatformObservable().subscribe((value) => {
        this.getSymptonCodes(value);
        this.getSectionCodes(value);
      });
    }
    this.formDatos.get('numserie1')?.valueChanges.subscribe((value) => {
      if (value.length === 2) {
        document.getElementById('numSerie2')?.focus();
      }
    });

    this.formDatos.get('numserie2')?.valueChanges.subscribe((value) => {
      if (value.length === 2) {
        document.getElementById('numSerie3')?.focus();
      }
    });

    this.formDatos.get('numserie3')?.valueChanges.subscribe((value) => {
      if (value.length === 6) {
        document.getElementById('numSerie4')?.focus();
      }
    });

    this.activeLang = this.translocoService.getActiveLang();
    this.translocoService.langChanges$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((newLang) => {
        this.activeLang = newLang;
      });
  }

  openMunicionRecomendada() {
    const dialogRef = this.dialog.open(MunicionRecomendadaComponent, {
      data: {},
      maxWidth: '100%',
      maxHeight: '100%',
      panelClass: 'custom-modal',
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  irAUrlAnterior() {
    if (this.step === 1) {
      this.router.navigate(['/login']);
    } else if (this.step === 2) {
      this.step = 1;
    }
  }

  ngAfterViewInit(): void {
    // Manejar el cambio de foco automáticamente
    this.formDatos.get('numserie1')!.valueChanges.subscribe((value) => {
      if (value.length === 2) {
        this.numSerie2Input.nativeElement.focus();
      }
    });

    this.formDatos.get('numserie2')!.valueChanges.subscribe((value) => {
      if (value.length === 2) {
        this.numSerie3Input.nativeElement.focus();
      }
    });

    this.formDatos.get('numserie3')!.valueChanges.subscribe((value) => {
      if (value.length === 6) {
        this.numSerie4Input.nativeElement.focus();
      }
    });
  }

  openPhotoCaptureDialog() {
    const dialogRef = this.dialog.open(PhotoCaptureComponent, {
      data: {
        onlyPhoto: this.step === 1 ? true : false,
        multipleSelectionEnabled: true,
      },
      maxWidth: '100%',
      maxHeight: '100%',
      panelClass: 'custom-modal',
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Resultado del cuadro de diálogo:', result);
      console.log(this.step);

      if (result) {
        for (const image of result) {
          this.adjuntos.push({
            base64: image.result,
            type: image.type,
            name:
              result.type === 'video'
                ? `Adjunto${this.adjuntos.length + 1}.webm`
                : `Adjunto${this.adjuntos.length + 1}.jpeg`,
          });
        }
      }
    });
  }

  goBack() {
    if (
      this.step === 3 &&
      this.formDatos.get('problema')?.value !== 0 &&
      this.formDatos.get('problema')?.value !== ''
    ) {
      this.step = 2;
    } else if (
      (this.step === 3 && this.formDatos.get('problema')?.value === 0) ||
      this.step === 2
    ) {
      this.step = 1;
    }
  }

  getPaises() {
    this.ubicacionesSvc
      .getPaises()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (data) => {
          console.log(data);
          this.paises = data;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getSymptonCodes(proyecto: any) {
    this.diagnosisService
      .getSymptonCodes(proyecto)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (v: any) => {
          console.log(v);
          this.symptonCodes = v;
        },
        error: (e) => {
          this.showSnackBarError(
            this.translocoService.translate('issue.error.loadSymptoms')
          );
        },
      });
  }

  getSectionCodes(proyecto: any) {
    this.diagnosisService
      .getSectionCodes(proyecto)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (v: any) => {
          console.log(v);
          this.sectionCodes = v;
        },
        error: (e) => {
          this.showSnackBarError(
            this.translocoService.translate('issue.error.loadSections')
          );
        },
      });
  }

  async getImagenPaso(idPaso: number, idImagen: number) {
    this.diagnosisService
      .getImagePasoCode(idPaso, idImagen)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res: any) => {
          console.log('Imagen descargada.');
          console.log(res);
          for (const seccion of this.pasosCategory) {
            for (const paso of seccion.pasos) {
              for (const imagen of paso.imagenes) {
                if (idImagen === imagen.ID) {
                  imagen.base64 = res.base64;
                }
              }
            }
          }
        },
        error: (e: any) => {},
      });
  }

  getPasos() {
    this.ticketsSvc
      .getCategoriesPasos(this.formDatos.get('problema')?.value)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res) => {
          console.log(res);
          this.pasosCategory = res.pasos;

          for (const seccion of res.pasos) {
            for (const paso of seccion.pasos) {
              for (const imagen of paso.imagenes) {
                this.getImagenPaso(paso.id, imagen.ID);
              }
            }
          }
        },
        error: (e) => {
          this.router.navigate(['/casos']);
        },
      });
  }

  deleteItemListMultimedia(adjunto: any) {
    this.adjuntos = this.adjuntos.filter((ad: any) => ad !== adjunto);
  }

  siguiente(where: 1 | 2 | 3) {
    if (!this.formDatos.valid) {
      this.showSnackBarError(
        this.translocoService.translate('issue.error.fillRequiredAndAccept')
      );
      const campos = [];
      this.camposBlocked = [];
      for (const campo in this.formDatos.controls) {
        if (this.formDatos.controls[campo].invalid) {
          campos.push(campo);
          this.camposBlocked.push(campo);
        }
      }
      console.log(campos);
    } else {
      this.step = where;
      if (where == 2) this.getPasos();
    }
  }

  crearTicket(status: any) {
    if (
      this.formDatos.get('email')?.value !== '' &&
      this.validarEmail(this.formDatos.get('email')?.value)
    ) {
      const numserieTemp =
        this.formDatos.get('numserie1')?.value +
        '.' +
        this.formDatos.get('numserie2')?.value +
        '.' +
        this.formDatos.get('numserie3')?.value +
        '.' +
        this.formDatos.get('numserie4')?.value;

      console.log(numserieTemp);
      if (
        !this.formDatos.get('numserie1')?.value ||
        this.formDatos.get('numserie1')?.value === '' ||
        !this.formDatos.get('numserie2')?.value ||
        this.formDatos.get('numserie2')?.value === '' ||
        !this.formDatos.get('numserie3')?.value ||
        this.formDatos.get('numserie3')?.value === '' ||
        !this.formDatos.get('numserie4')?.value ||
        this.formDatos.get('numserie4')?.value === ''
      ) {
        this.showSnackBarError(
          this.translocoService.translate('issue.error.invalidSerial')
        );
      } else {
        this.ticketsSvc
          .comprobarActivo(numserieTemp)
          .pipe(takeUntil(this.destroyed$))
          .subscribe({
            next: (v) => {
              console.log('coincidencia: ', v);
              //Crear ticket -->
              const data = {
                FK_entities: v?.almacen?.almacenes_proyectos[0]?.id_proyecto,
                name:
                  v?.serial +
                  ' - ' +
                  this.formDatos.get('nombre')?.value +
                  ' ' +
                  this.formDatos.get('apellidos')?.value,
                contents: `<p>Nombre: <strong>${
                  this.formDatos.get('nombre')?.value
                }</strong></p>
                            <p>Apellidos: <strong>${
                              this.formDatos.get('apellidos')?.value
                            }</strong></p>
                            <p>Email: <strong>${
                              this.formDatos.get('email')?.value
                            }</strong></p>
                            <p>Teléfono: <strong>${
                              this.formDatos.get('phone')?.value
                            }</strong></p>
                            <p>Código Postal: <strong>${
                              this.formDatos.get('cp')?.value
                            }</strong></p><p>Motivo: <strong>${
                  this.formDatos.get('motivo')?.value
                }</strong></p>`,
                numserie: v?.serial,
                tipoDispositivo: v?.elemento?.dispositivo,
                marca_id: v?.elemento?.marca,
                modelo_id: v?.elemento?.modelo,
                pn: v?.elemento?.PN,
                assign: 0,
                assign_ent: 0,
                fk_elemento_almacen: v?.id,
                status: status,
              };

              this.ticketsSvc
                .crearTicket(data)
                .pipe(takeUntil(this.destroyed$))
                .subscribe({
                  next: (ticket) => {
                    console.log(ticket);

                    if (status !== 'old_done') {
                      this.mailService
                        .sendMailConfirmacion(
                          this.formDatos.get('email')?.value,
                          ticket.ticket.ID,
                          v?.serial,
                          this.formDatos.get('nombre')?.value +
                            ' ' +
                            this.formDatos.get('apellidos')?.value,
                          true
                        )
                        .pipe(takeUntil(this.destroyed$))
                        .subscribe({
                          next: (res: any) => {
                            console.log(res);
                          },
                          error: (e: any) => {
                            this.showSnackBarError(
                              this.translocoService.translate(
                                'issue.error.confirmationEmail'
                              )
                            );
                          },
                        });
                    }

                    this.diagnosisService
                      .createDiagnosis(
                        'Diagnosis area de clientes',
                        data.contents,
                        this.formDatos.get('problema')?.value === 0
                          ? null
                          : this.formDatos.get('problema')?.value,
                        this.formDatos.get('seccion')?.value === ''
                          ? null
                          : this.formDatos.get('seccion')?.value,
                        ticket.ticket.ID,
                        data.numserie
                      )
                      .pipe(takeUntil(this.destroyed$))
                      .subscribe({
                        next: (res: any) => {
                          this.showSnackBarSuccess(
                            this.translocoService.translate(
                              'issue.success.issueCreated'
                            )
                          );
                          this.router.navigate(['/login']);
                        },
                        error: (e: any) => {
                          this.showSnackBarError(
                            this.translocoService.translate(
                              'issue.error.createDiagnosis'
                            )
                          );
                        },
                      });

                    for (const adjunto of this.adjuntos) {
                      this.ticketsSvc
                        .uploadAdjunto(
                          v.ticket.ID,
                          adjunto.type === 'video' ? 1 : 6,
                          adjunto.name,
                          adjunto.base64
                        )
                        .pipe(takeUntil(this.destroyed$))
                        .subscribe(
                          (data2) => {
                            console.log('Data file upload', data2);
                          },
                          (err) => {
                            console.log(err);
                            this.showSnackBarError(
                              this.translocoService.translate(
                                'issue.error.uploadAttachment'
                              )
                            );
                          }
                        );
                    }
                  },
                  error: (e) => {
                    this.showSnackBarError(
                      this.translocoService.translate(
                        'issue.error.createTicket'
                      )
                    );
                  },
                });
            },
            error: (e) => {
              this.showSnackBarError(
                this.translocoService.translate('issue.error.serialNotFound')
              );
            },
          });
      }
    } else {
      if (this.formDatos.get('email')?.value) {
        this.showSnackBarError(
          this.translocoService.translate('issue.error.invalidEmail')
        );
      }
      this.validEmail = false;
    }
  }

  showSnackBarSuccess(mensaje: string) {
    this.snackBarService.openSnackBarSuccess(mensaje);
  }

  validarEmail(email: string) {
    const emailRegExp: RegExp =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    if (email) {
      if (!emailRegExp.test(email)) {
        return false;
      }
    }

    return true;
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  showSnackBarError(mensaje: string) {
    this.snackBarService.openSnackBarError(mensaje);
  }
}
